import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, TextInput } from 'carbon-components-react';
import { idAttribute } from '../../component_helpers/IDHelper';
import { idePrefix } from '../../globals/js/settings';
export var MEDIUM_IMPACT = 'medium';
export var HIGH_IMPACT = 'high';

var IdeRemove = /*#__PURE__*/function (_React$Component) {
  _inherits(IdeRemove, _React$Component);

  var _super = _createSuper(IdeRemove);

  function IdeRemove(props) {
    var _this;

    _classCallCheck(this, IdeRemove);

    _this = _super.call(this, props);
    _this.state = {
      itemName: '',
      didDelete: false
    };
    _this.textFieldChange = _this.textFieldChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IdeRemove, [{
    key: "textFieldChange",
    value: function textFieldChange(evt) {
      if (evt && evt.target && evt.target.value) {
        this.setState({
          itemName: evt.target.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
          open = _ref.open,
          closeIconDescription = _ref.closeIconDescription,
          removeType = _ref.removeType,
          cancelText = _ref.cancelText,
          deleteText = _ref.deleteText,
          onClose = _ref.onClose,
          onDelete = _ref.onDelete,
          deleteContent = _ref.deleteContent,
          postDeleteContent = _ref.postDeleteContent,
          highImpactItemName = _ref.highImpactItemName,
          highImpactTextFieldLabel = _ref.highImpactTextFieldLabel,
          others = _objectWithoutProperties(_ref, ["open", "closeIconDescription", "removeType", "cancelText", "deleteText", "onClose", "onDelete", "deleteContent", "postDeleteContent", "highImpactItemName", "highImpactTextFieldLabel"]);

      var didDelete = postDeleteContent ? this.state.didDelete : false;
      var content = this.state.didDelete && postDeleteContent ? postDeleteContent : deleteContent;
      return /*#__PURE__*/React.createElement("div", _extends({}, others, idAttribute('IdeRemove-root')), /*#__PURE__*/React.createElement(Modal, _extends({
        open: open,
        danger: true,
        passiveModal: postDeleteContent && didDelete
      }, idAttribute('IdeRemove-modal'), {
        modalLabel: content.label,
        modalHeading: content.heading,
        "aria-label": content.label,
        iconDescription: closeIconDescription,
        primaryButtonText: deleteText,
        secondaryButtonText: cancelText,
        onRequestClose: onClose,
        onRequestSubmit: function onRequestSubmit() {
          _this2.setState({
            didDelete: true
          });

          onDelete();
        },
        primaryButtonDisabled: removeType === HIGH_IMPACT && highImpactItemName !== this.state.itemName
      }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", idAttribute('IdeRemove-modal-body'), content.body), removeType === HIGH_IMPACT && !didDelete ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(idePrefix, "-remove--modal-body-textfield-container")
      }, /*#__PURE__*/React.createElement(TextInput, _extends({}, idAttribute('IdeRemove-modal-body-high-impact-textfield'), {
        onChange: this.textFieldChange,
        id: "IdeRemove-high-impact-".concat(highImpactItemName),
        labelText: highImpactTextFieldLabel
      }))) : null)));
    }
  }]);

  return IdeRemove;
}(React.Component);

IdeRemove.propTypes = {
  /** Text which appears in the cancel button. Must be a pre translated string.  */
  cancelText: PropTypes.string.isRequired,

  /** Label text for the modal - must be a pre translated string */
  closeIconDescription: PropTypes.string.isRequired,

  /** deleteContent - the text displayed before a user clicks delete or remove. Required.  */
  deleteContent: PropTypes.shape({
    label: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  }).isRequired,

  /** Text which appears in the delete button before being clicked. Must be a pre translated string. */
  deleteText: PropTypes.string.isRequired,

  /** if a high impact remove, this is the name of the item being removed. This must be provided. */
  highImpactItemName: PropTypes.string,

  /** if a high impact remove, this is the label for the text field. Must be a pre translated string */
  highImpactTextFieldLabel: PropTypes.string,

  /** Callback which is invoked when the user selects cancel/closes the modal */
  onClose: PropTypes.func,

  /** Callback which is invoked when the user confirms the delete. Only invoked after the configured delay occurs */
  onDelete: PropTypes.func,

  /** Modal open/closed state. */
  open: PropTypes.bool,

  /** postDeleteContent - the text displayed after a user clicks delete. Optional. */
  postDeleteContent: PropTypes.shape({
    label: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  }),

  /** Tye type of delete/remove which is being performed. See the readme for when to use which mode */
  removeType: PropTypes.oneOf([MEDIUM_IMPACT, HIGH_IMPACT])
};
IdeRemove.defaultProps = {
  open: false,
  closeIconDescription: 'Close modal - provide a translated string',
  removeType: MEDIUM_IMPACT,
  cancelText: 'Cancel - provide a translated string',
  deleteText: 'Delete - provide a translated string',
  onDelete: null,
  onClose: null,
  deleteContent: {
    label: 'Remove Label - provide a translated string',
    heading: 'Remove Heading - provide a translated string',
    body: 'Remove Body - provide a translated string'
  },
  highImpactItemName: 'my entity name',
  highImpactTextFieldLabel: 'Confrim remove of [name] - provide a translated string'
};
export default IdeRemove;